import { c as _c } from "react/compiler-runtime";
import { LazyImage } from "@website/ui/lazy-image";
import { Fragment } from "react";
import type { VillaHostStepItem } from "../../villa-host.types";
import { VillaHostStepCard } from "./VillaHostStepCard";
export const VillaHostStepSection = t0 => {
  const $ = _c(13);
  const {
    steps
  } = t0;
  let t1;
  if ($[0] !== steps) {
    let t2;
    if ($[2] !== steps.length) {
      t2 = (step, index) => {
        const isFirstStep = index === 0;
        const isLastStep = index === steps.length - 1;
        return <Fragment key={step.title}><VillaHostStepCard {...step} beforeIcon={isFirstStep ? step.before : undefined} afterIcon={isLastStep ? step.after : undefined} />{!isLastStep && step.after && <div className="flex items-center justify-center pt-8"><LazyImage alt="" src={step.after} className="h-[58px] w-auto object-contain" /></div>}</Fragment>;
      };
      $[2] = steps.length;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = steps.map(t2);
    $[0] = steps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="hidden lg:grid lg:grid-cols-[1fr_auto_1fr_auto_1fr] lg:items-start lg:pb-24">{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== steps) {
    t3 = steps.map(_temp);
    $[6] = steps;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="flex flex-col gap-10 lg:hidden">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(step_0) {
  return <VillaHostStepCard key={step_0.title} {...step_0} />;
}